import React, {useState} from 'react';

import {TextInput, INPUT_SIZE} from '../../../atoms/text-input';
import {UrlInput} from '../../url-input';

import styles from './styles.module.css';

type Props = {
    label?: string;
    limit: number;
    displayName: string;
    displayNameError?: string;
    onDisplayNameChange: (displayName: string) => void;
    urlLabel?: string;
    baseUrl: string;
    path: string;
    url: string;
    urlError?: string;
    showUrlError?: boolean;
    urlShortenLength: number;
    onUrlChange: (url: string) => void;
    editButtonMessage?: React.ReactNode;
    doneButtonMessage?: React.ReactNode;
};

export const ChannelNameInput = (props: Props) => {
    const {
        label,
        limit,
        displayName,
        displayNameError,
        onDisplayNameChange,
        baseUrl,
        path,
        urlShortenLength,
        urlError,
        showUrlError,
        onUrlChange,
        url,
        urlLabel,
        editButtonMessage,
        doneButtonMessage,
    } = props;
    const [displayNameModified, setDisplayNameModified] = useState(false);

    const handleOnDisplayNameChange = (value: React.ChangeEvent<HTMLInputElement> | string) => {
        onDisplayNameChange(value as string);
    };

    const handleOnDisplayNameBlur = () => {
        if (!displayNameModified) {
            setDisplayNameModified(true);
        }
    };
    const handleOnURLChange = (url: string) => {
        onUrlChange(url);
    };

    return (
        <div>
            <TextInput
                type='text'
                size={INPUT_SIZE.MEDIUM}
                autoComplete='off'
                autoFocus={true}
                required={true}
                label={label}
                limit={limit}
                value={displayName}
                errorMessage={displayNameModified ? displayNameError : ''}
                validationState={displayNameError ? 'invalid' : 'valid'}
                onChange={handleOnDisplayNameChange}
                onBlur={handleOnDisplayNameBlur}
            />
            <UrlInput
                className={styles.urlInput}
                base={baseUrl}
                label={urlLabel}
                path={path}
                pathInfo={url}
                limit={limit}
                shortenLength={urlShortenLength}
                error={urlError}
                showError={showUrlError}
                onChange={handleOnURLChange}
                editButtonMessage={editButtonMessage}
                doneButtonMessage={doneButtonMessage}
            />
        </div>
    );
};
